export default __webpack_public_path__ + "static/media/a5d8f5b9-8abf-4e5f-9304-befda49f812e.8edd10f4.jpg";